import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import { DialogTitleWithClose } from '../../common';
import ThemeForm from './ThemeForm';

/**
 * ThemeFormDialog Component
 *
 * A dialog wrapper for the theme form with:
 * - Create/Edit theme functionality
 * - Loading states
 * - Form validation and submission
 */
const ThemeFormDialog = ({
  open,
  currentThemeItem,
  formData,
  loading,
  onClose,
  onSubmit,
  onChange,
  onColorChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitleWithClose
        title={currentThemeItem ? 'Edit Theme' : 'Create New Theme'}
        onClose={onClose}
        disableClose={loading}
      />
      <DialogContent>
        <ThemeForm
          formData={formData}
          currentThemeItem={currentThemeItem}
          onChange={onChange}
          onColorChange={onColorChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {currentThemeItem ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThemeFormDialog;
